import { graphql } from 'gql';

export const bimWorkOrderChangePriceGql = graphql(`
    query bimWorkOrderChangePrices(
        $workOrderChangeId: Long!
        $workOrderRootObjectId: Long
        $workOrderChangeRootObjectId: Long
        $chapter: BimChapterEnum!
        $includeRows: Boolean!
        $priceLevel: BimPriceLevelEnum
        $where: BimWorkOrderChangePriceDataFilterInput
        $order: [BimWorkOrderChangePriceDataSortInput!]
        $skip: Int
        $take: Int
    ) {
        bimWorkOrderChangePrices(
            workOrderChangeId: $workOrderChangeId
            workOrderRootObjectId: $workOrderRootObjectId
            workOrderChangeRootObjectId: $workOrderChangeRootObjectId
            chapter: $chapter
            includeRows: $includeRows
            priceLevel: $priceLevel
            where: $where
            order: $order
            skip: $skip
            take: $take
        ) {
            items {
                workOrderPriceId
                workOrderChangePriceId
                workOrderObjectId
                workOrderChangeObjectId
                object {
                    workOrderObjectId
                    workOrderChangeObjectId
                    contractObjectId
                    name
                }
                chapter
                planValue {
                    code
                    name
                    unit
                    quantity
                    smrTotal
                    ozp
                    emm
                    zpm
                    mp
                    nr
                    sp
                    op
                    others
                    total
                    mz
                    oz
                    tzr
                }
                completedValue {
                    code
                    name
                    unit
                    quantity
                    smrTotal
                    ozp
                    emm
                    zpm
                    mp
                    nr
                    sp
                    op
                    others
                    total
                    mz
                    oz
                    tzr
                }
                remainderValue {
                    code
                    name
                    unit
                    quantity
                    smrTotal
                    ozp
                    emm
                    zpm
                    mp
                    nr
                    sp
                    op
                    others
                    total
                    mz
                    oz
                    tzr
                }
                priceRows {
                    id
                    workOrderPriceId
                    workOrderChangePriceId
                    type
                    workOrderSectionId
                    workOrderChangeSectionId
                    sectionName
                    value {
                        code
                        name
                        unit
                        quantity
                        smrTotal
                        ozp
                        emm
                        zpm
                        mp
                        nr
                        sp
                        op
                        others
                        total
                        mz
                        oz
                        tzr
                    }
                }
                isRevisionPrice
                isUpdatedPrice
                hasRevisions
                hasUpdates
                isLimitPrice
                isActKC2Price
                isAddedRow
                isRemovedRow
                isExcludedRow
                hasActKC2
                canRemoved
                completedTotalDeviation
                rationale
            }
            totalCount
        }
    }
`);

export const bimWorkOrderChangeDeletePriceGql = graphql(`
    mutation bimRemoveWorkOrderChangePrices($workOrderChangeId: Long!, $priceIds: [BimWorkOrderChangePriceIdsInput!]!) {
        bimRemoveWorkOrderChangePrices(workOrderChangeId: $workOrderChangeId, priceIds: $priceIds) {
            data
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimWorkOrderChangePriceCodeFilterGql = graphql(`
    query bimWorkOrderChangePriceCodeFilter(
        $workOrderChangeId: Long!
        $workOrderRootObjectId: Long
        $workOrderChangeRootObjectId: Long
        $chapter: BimChapterEnum!
        $where: FilterValueOfStringFilterInput
    ) {
        bimWorkOrderChangePriceCodeFilter(
            workOrderChangeId: $workOrderChangeId
            chapter: $chapter
            workOrderRootObjectId: $workOrderRootObjectId
            workOrderChangeRootObjectId: $workOrderChangeRootObjectId
            where: $where
        ) {
            items {
                value
            }
        }
    }
`);

export const bimWorkOrderChangePriceNameFilterGql = graphql(`
    query bimWorkOrderChangePriceNameFilter(
        $workOrderChangeId: Long!
        $workOrderRootObjectId: Long
        $workOrderChangeRootObjectId: Long
        $chapter: BimChapterEnum!
        $where: FilterValueOfStringFilterInput
    ) {
        bimWorkOrderChangePriceNameFilter(
            workOrderChangeId: $workOrderChangeId
            chapter: $chapter
            workOrderRootObjectId: $workOrderRootObjectId
            workOrderChangeRootObjectId: $workOrderChangeRootObjectId
            where: $where
        ) {
            items {
                value
            }
        }
    }
`);

export const bimWorkOrderChangePriceObjectNameFilterGql = graphql(`
    query bimWorkOrderChangePriceObjectNameFilter(
        $workOrderChangeId: Long!
        $workOrderRootObjectId: Long
        $workOrderChangeRootObjectId: Long
        $chapter: BimChapterEnum!
        $where: FilterValueOfStringFilterInput
    ) {
        bimWorkOrderChangePriceObjectNameFilter(
            workOrderChangeId: $workOrderChangeId
            workOrderRootObjectId: $workOrderRootObjectId
            workOrderChangeRootObjectId: $workOrderChangeRootObjectId
            chapter: $chapter
            where: $where
        ) {
            items {
                value
            }
        }
    }
`);

export const bimWorkOrderChangePriceRationaleFilterGql = graphql(`
    query bimWorkOrderChangePriceRationaleFilter(
        $workOrderChangeId: Long!
        $workOrderRootObjectId: Long
        $workOrderChangeRootObjectId: Long
        $chapter: BimChapterEnum!
        $where: FilterValueOfStringFilterInput
    ) {
        bimWorkOrderChangePriceRationaleFilter(
            workOrderChangeId: $workOrderChangeId
            workOrderRootObjectId: $workOrderRootObjectId
            workOrderChangeRootObjectId: $workOrderChangeRootObjectId
            chapter: $chapter
            where: $where
        ) {
            items {
                value
            }
        }
    }
`);

export const bimWorkOrderChangePriceDetailsGql = graphql(`
    query bimWorkOrderChangePriceRows(
        $skip: Int
        $take: Int
        $workOrderPriceId: Long
        $workOrderChangePriceId: Long
        $priceLevel: BimPriceLevelEnum
        $where: BimWorkOrderChangePriceRowDataFilterInput
        $order: [BimWorkOrderChangePriceRowDataSortInput!]
    ) {
        bimWorkOrderChangePriceRows(
            skip: $skip
            take: $take
            workOrderPriceId: $workOrderPriceId
            workOrderChangePriceId: $workOrderChangePriceId
            priceLevel: $priceLevel
            where: $where
            order: $order
        ) {
            items {
                id
                workOrderPriceId
                workOrderChangePriceId
                type
                workOrderSectionId
                workOrderChangeSectionId
                sectionName
                value {
                    code
                    name
                    unit
                    quantity
                    smrTotal
                    ozp
                    emm
                    zpm
                    mp
                    nr
                    sp
                    op
                    others
                    total
                    mz
                    oz
                    tzr
                }
            }
            totalCount
        }
    }
`);

export const bimWorkOrderChangeRevisionsGql = graphql(`
    query bimWorkOrderChangePriceRevisions(
        $skip: Int
        $take: Int
        $workOrderPriceId: Long
        $workOrderChangePriceId: Long
        $revisionType: WorkOrderPriceRevisionTypeEnum
        $priceLevel: BimPriceLevelEnum
        $where: BimWorkOrderChangePriceRevisionDataFilterInput
        $order: [BimWorkOrderChangePriceRevisionDataSortInput!]
    ) {
        bimWorkOrderChangePriceRevisions(
            skip: $skip
            take: $take
            workOrderPriceId: $workOrderPriceId
            workOrderChangePriceId: $workOrderChangePriceId
            revisionType: $revisionType
            priceLevel: $priceLevel
            where: $where
            order: $order
        ) {
            totalCount
            items {
                workOrderPriceId
                workOrderChangePriceId
                planValue {
                    code
                    name
                    unit
                    quantity
                    smrTotal
                    ozp
                    emm
                    zpm
                    mp
                    nr
                    sp
                    op
                    others
                    total
                    mz
                    oz
                    tzr
                }
                completedValue {
                    code
                    name
                    unit
                    quantity
                    smrTotal
                    ozp
                    emm
                    zpm
                    mp
                    nr
                    sp
                    op
                    others
                    total
                    mz
                    oz
                    tzr
                }
                remainderValue {
                    code
                    name
                    unit
                    quantity
                    smrTotal
                    ozp
                    emm
                    zpm
                    mp
                    nr
                    sp
                    op
                    others
                    total
                    mz
                    oz
                    tzr
                }
                isRevisionPrice
                isUpdatedPrice
                order
                priceUpdateDate
            }
        }
    }
`);
